// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './router/check'
import './validate/validate'
import * as filters from '@/filters/index'

import '../static/weixin/css/weui.min.css'
import '../static/weixin/css/styles.css'

import Notification from './components/Notification'
import 'mint-ui/lib/style.css'
import { Loadmore } from 'mint-ui'
import { CellSwipe } from 'mint-ui'
import { Actionsheet } from 'mint-ui'
import { InfiniteScroll } from 'mint-ui';
import { Spinner } from 'mint-ui';
import { Popup } from 'mint-ui';
import { Switch } from 'mint-ui';
import { Search } from 'mint-ui';
import { Cell } from 'mint-ui';
import { DatetimePicker } from 'mint-ui';
import { Swipe, SwipeItem } from 'mint-ui';

import Vue2TouchEvents from 'vue2-touch-events'

Vue.component('Notification',Notification)
Vue.component(Switch.name, Switch);
Vue.component(Popup.name, Popup);
Vue.component(Loadmore.name, Loadmore)
Vue.component(CellSwipe.name, CellSwipe)
Vue.component(Actionsheet.name, Actionsheet)
Vue.use(InfiniteScroll)
Vue.component(Spinner.name, Spinner);
Vue.use(Vue2TouchEvents)
Vue.component(Search.name, Search);
Vue.component(Cell.name, Cell);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);



//Vue.$messagebox = Vue.prototype.$messagebox = MessageBox;

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
  	App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js